export const PUBLIC_URL =
  process.env.NODE_ENV === "development"
    ? "https://192.168.1.217:3006"
    : "https://milano.viaggiar.it";
export default PUBLIC_URL;
